import Events from "./events";

export default class GameListeners {
    constructor(gb) {
        Object.assign(this, { gb, ...(new Events(gb).exposeEvents()) })
    }
}
